import { StressLine } from './AbioticGraph.styles';

const AbioticGraph = ({
  positionData,
  stressValue,
  type,
  hasDottedLineAtStart,
  hasDottedLineAtEnd,
  isVisible,
}: {
  positionData: {
    left: number;
    width: number;
  };
  stressValue: number;
  type: string;
  hasDottedLineAtStart: boolean;
  hasDottedLineAtEnd: boolean;
  isVisible: boolean;
}) => {
  return (
    <StressLine
      left={positionData.left}
      width={positionData.width}
      stressValue={stressValue}
      type={type}
      hasDottedLineAtStart={hasDottedLineAtStart}
      hasDottedLineAtEnd={hasDottedLineAtEnd}
      isVisible={isVisible}
    />
  );
};

export default AbioticGraph;
